import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export default class Request {
  public static sendRequest(url: string, configs?: AxiosRequestConfig): Promise<AxiosResponse> {
    const fullUrl = process.env.REACT_APP_API_URL + url;
    return axios.request({
      url: fullUrl,
      ...configs
    });
  }
}
